import {
    Flex,
    Grid,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import { useTracker } from '@archipro-website/tracker';
import * as S from '@modules/project/component/about-professional/SocialLinks.style';
import type { SocialLink } from '@modules/project/util/make-social-links';
import { trackSocialMediaClick } from '~/modules/tracking/util/trackSocialMediaClick';

interface StatsProps {
    links: SocialLink[];
}

const SocialLinks = ({ links }: StatsProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const tracker = useTracker();
    return (
        <Flex data-testid="social" className={css(S.Socials)}>
            <Grid columns={mobile ? 3 : 6}>
                {links.map((platform) => (
                    <a
                        key={`social-${platform.Label}`}
                        href={platform.Link}
                        target={'_blank'}
                        className={css(S.Social)}
                        rel="noopener"
                        onClick={() => {
                            trackSocialMediaClick(
                                platform.Label,
                                platform.itemID,
                                platform.title,
                                tracker
                            );
                        }}
                    >
                        {platform.Icon}
                    </a>
                ))}
            </Grid>
        </Flex>
    );
};

export default SocialLinks;
